export enum ConsentCheckbox {
  Marketing = 'Marketing',
  MarketingPartners = 'Marketing partners',
}
